<p-dialog [(visible)]="invoice" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '75vw' }">
	<div class="d-flex flex-column">
		<div class="d-flex">
			<img
				src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/{{ venueService.subscriptionVenue.value.dealerKey }}.png"
				alt="Dealer Logo"
				width="300px"
				height="auto"
			/>
			<div class="ms-auto my-auto h1">
				{{ invoice.referenceString }}
			</div>
		</div>
		<div class="d-flex">
			<div class="d-flex flex-column ms-auto">
				<div class="p-grid">
					<div class="p-col h4">Created:</div>
					<div class="p-col h4">
						{{ app.moment(invoice.createdDate).format("l") }}
					</div>
				</div>
				<div class="p-grid">
					<div class="p-col h4">Due:</div>
					<div class="p-col h4">
						{{ app.moment(invoice.dueDate).format("l") }}
					</div>
				</div>
				<div class="p-grid">
					<div class="p-col h4">Total:</div>
					<div class="p-col h4">
						{{ invoice.total | currency }}
					</div>
				</div>
				<div class="p-grid">
					<div class="p-col h4" [ngClass]="invoice.balanceDue > 0 ? 'text-danger' : ''">
						<span *ngIf="invoice.balanceDue > 0 && app.moment(invoice.dueDate).isBefore(app.moment())" class="text-danger">Past due</span>
						<span *ngIf="!app.moment(invoice.dueDate).isBefore(app.moment())">Due</span>
					</div>
					<div class="p-col">
						{{ invoice.balanceDue | currency }}
					</div>
				</div>
			</div>
		</div>
		<p-divider></p-divider>
		<app-invoice-record-lines [(invoice)]="invoice"></app-invoice-record-lines>
		<div class="mt-2" *ngIf="invoice.payments">
			<p-divider type="dashed">Payments</p-divider>
			<div *ngIf="invoice.payments?.length > 0" class="d-flex flex-wrap">
				<ng-container *ngFor="let payment of invoice.payments">
					<div class="card m-2 h-100">
						{{ app.moment(payment.date).format("l") }}
						<div class="p-grid">
							<div class="p-col">{{ payment.method }} {{ payment.account }}</div>
							<div class="p-col">
								{{ payment.amount | currency }}
							</div>
						</div>
					</div>
				</ng-container>
			</div>
			<div *ngIf="invoice.payments?.length === 0" class="d-flex flex-wrap">
				<div class="card m-2 h-100">
					<div class="h4">No payments applied</div>
				</div>
			</div>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideCancel]=""
			[hideDelete]="true"
			[hideSave]="invoice.balanceDue === 0"
			(onCancelChange)="invoiceChange.emit(undefined)"
			(onSaveChange)="initInvoicePay()"
			[cancelDisabled]=""
			[deleteDisabled]=""
			[saveDisabled]="invoice.balanceDue === 0"
			saveLabel="Pay Invoice"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
